/* eslint-disable react/prop-types */
import * as yup from "yup";
import { v4 as uuid } from "uuid";
import { TYPE_FIELD_LIST } from "../../../helper/TypeFieldList";
import { useMemo } from "react";
import { MESSAGE } from "../../../message";

export default function useManufacturerSchema({ item }) {
  const manufacturerFieldList = useMemo(
    () => [
      {
        id: uuid(),
        name: "name",
        label: "Tên nhà sản xuất",
        typeField: TYPE_FIELD_LIST.TEXTFIELD,
        type: "text",
        defaultValue: "",
        grid: [12],
        placeHolder: MESSAGE.MANUFACTURER_NAME,
        required: true,
      },
      {
        id: uuid(),
        name: "origin",
        label: "Tên xuất xứ",
        typeField: TYPE_FIELD_LIST.TEXTFIELD,
        type: "text",
        defaultValue: "",
        grid: [12],
        placeHolder: MESSAGE.ORIGIN_NAME,
        required: true,
      },
    ],
    [],
  );

  const validationSchema = yup.object().shape({
    name: yup.string().required(MESSAGE.PLEASE_FILL_MANUFACTURER),
    origin: yup.string().required(MESSAGE.PLEASE_FILL_ORIGIN),
  });

  const manuObject = {
    name: item?.name ?? undefined,
    origin: item?.origin ?? undefined,
  };

  return { manufacturerFieldList, validationSchema, manuObject };
}
